import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Button } from 'foundations-components/transitional/components/Button';
import { useState } from 'react';
import I18n from 'I18n';
// @ts-expect-error Untyped import
import ColorPickerPopoverBody from 'react-colorpicker/popover/ColorPickerPopoverBody';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { ColorSwatch } from 'foundations-components/transitional/components/ColorSwatch';
import { DEFAULT_TAG_COLOR } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TagNameForm = ({
  name,
  color = DEFAULT_TAG_COLOR,
  onNameChange,
  onColorChange
}) => {
  const [colorIsOpen, setColorIsOpen] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      label: I18n.text('reporting-action-components.actions.tagManager.modal.fields.name'),
      required: true,
      children: /*#__PURE__*/_jsx(TextInput, {
        "data-test-id": "tag-name-input",
        onChange: ({
          target = {}
        }) => onNameChange(target.value),
        value: name
      })
    }), /*#__PURE__*/_jsx(Popover, {
      onOpenChange: ({
        target: {
          value
        }
      }) => setColorIsOpen(value),
      open: colorIsOpen,
      inlineSize: "300px",
      content: /*#__PURE__*/_jsx(ColorPickerPopoverBody, {
        color: color,
        onChange: ({
          color: newColor
        }) => onColorChange(newColor)
      }),
      children: /*#__PURE__*/_jsx(FormControl, {
        label: I18n.text('reporting-action-components.actions.tagManager.modal.fields.color'),
        required: true,
        children: /*#__PURE__*/_jsxs(Button, {
          use: "form",
          block: true,
          onClick: () => setColorIsOpen(!colorIsOpen),
          children: [/*#__PURE__*/_jsx(ColorSwatch, {
            color: color,
            size: 10
          }), color]
        })
      })
    })]
  });
};
export default TagNameForm;